export enum Rating {
  A = 'A',
  B = 'B',
  C = 'C',
  D = 'D',
  E = 'E',
  S = 'S',
}
